import { createContext, useContext, useEffect, useState } from "react";

const ContactDetailsContext = createContext();
const VideoPopupContext = createContext();

export const useContactDetails = () => useContext(ContactDetailsContext);
export const useVideoPopup = () => useContext(VideoPopupContext);

export const ContactDetailsProvider = ({ children }) => {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    let timeout = setTimeout(() => {
      setShowVideo(true);
    }, 25000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <ContactDetailsContext.Provider
      value={{
        phone: "+919907100200",
        displayNumber: "+91 (990) 710 0200",
        whatsappNumber: "+919211413907",
        whatsappText: "Hi, I am looking for an office space",
      }}
    >
      <VideoPopupContext.Provider value={{ showVideo, setShowVideo }}>
        {children}
      </VideoPopupContext.Provider>
    </ContactDetailsContext.Provider>
  );
};

export const showing_number = "+91 (828) 799 9888";
export const calling_number = "+918287999888";
